<div
  class="light character-sheet"
  [style.--ghs-character-color]="character.color"
  [ngClass]="{ 'cs-sheet': csSheet, 'fh-sheet': fhSheet, 'gh2e-sheet': gh2eSheet, compact: settingsManager.settings.characterSheetCompact }"
>
  <div
    class="container"
    [ngClass]="{
      denied:
        (!forceEdit() && (!editable() || !gameManager.stateManager.characterPermissions[character.name + '|' + character.edition])) ||
        settingsManager.settings.characterSheetLocked,
      'view-only': (!forceEdit() && !editable()) || settingsManager.settings.characterSheetLocked
    }"
  >
    <div class="columns">
      <div class="column column-left">
        <div class="row title">
          <img [src]="character.iconUrl" />
          <label class="headline" [ghs-label]="character.absent ? 'character.absent' : 'character.present'" [ghs-label-attribute]="'title'">
            <div class="character-title">
              <span
                [ghs-label]="'character.progress.title'"
                [ghs-label-args]="[
                  'data.character.' + character.edition + '.' + character.name,
                  character.characterClass
                    ? 'character.class.' + (character.gender ? character.gender + '.' : '') + character.characterClass
                    : ''
                ]"
              ></span>
            </div>
            <img
              (click)="toggleCharacterAbsent()"
              class="absent"
              [src]="'./assets/images/status/' + (character.absent ? 'absent' : 'present') + '.svg'"
              [ghs-label]="character.absent ? 'character.present' : 'character.absent'"
              [ghs-label-attribute]="'title'"
            />
          </label>
        </div>
        <div class="row base">
          <div class="name">
            <label><span [ghs-label]="'character.progress.name'"></span>:</label>
            @if (titles.length === 0 || !settingsManager.settings.characterIdentities) {
              <input #charactertitle type="text" [value]="character.title" (change)="titleChange()" />
            }
            @if (titles.length > 0 && settingsManager.settings.characterIdentities) {
              @for (i of [] | ghsRange: character.identities.length; track i) {
                <img [src]="gameManager.characterManager.characterIdentityIcon(character.name, i)" />
                <input type="text" [value]="titles[i]" (change)="setTitle($event, i)" />
              }
            }
          </div>
          <div class="level">
            <div class="columns">
              <div class="column">
                <label><span [ghs-label]="'character.progress.level'"></span> <img src="./assets/images/level.svg" />:</label>
                <label><span [ghs-label]="'character.progress.xp'"></span> <img src="./assets/images/experience.svg" />:</label>
              </div>
              <div class="column">
                <div class="level-grid">
                  @for (level of [] | ghsRange: 9; track level) {
                    <div class="checkbox level-item" [ngClass]="{ checked: character.level > level }" (click)="setLevel(level + 1)">
                      {{ level + 1 }}
                    </div>
                  }
                  @for (level of [] | ghsRange: 9; track level) {
                    <div
                      class="xp-item"
                      [ngClass]="{ checked: character.progress.experience >= gameManager.characterManager.xpMap[level] }"
                      (click)="setLevel(level + 1)"
                    >
                      {{ gameManager.characterManager.xpMap[level] }}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="xp-gold-container">
          <div class="row xp-notes">
            <label
              ><span [ghs-label]="'character.progress.xp'"></span> <img src="./assets/images/experience.svg" />
              @if (!fhSheet) {
                <span><span [ghs-label]="'character.progress.notes'"></span></span>
              }
              :</label
            >
            <input [value]="character.progress.experience" type="number" min="0" (change)="setXP($event)" />
          </div>
          <div class="row gold-notes">
            @if (!fhSheet) {
              <label><span [ghs-label]="'character.progress.gold-notes'"></span>:</label>
            }
            @if (fhSheet) {
              <label><span [ghs-label]="'character.progress.gold'"></span> <img src="./assets/images/fh/loot.svg" />:</label>
            }
            <input [value]="character.progress.gold" type="number" min="0" (change)="setGold($event)" />
            @if (donations) {
              <span class="donations">
                <span [ghs-label]="'character.progress.donations'" [ghs-label-args]="[character.progress.donations]"></span>
              </span>
            }
            @if (donations) {
              <span class="donate">
                <span [ghs-label]="'character.progress.donate'"></span>:
                <a
                  (click)="donate()"
                  [ngClass]="{ disabled: character.progress.gold < (donations === 'fh' ? 5 : 10) || gameManager.game.round > 0 }"
                  ><span class="price"><img src="./assets/images/loot.svg" />{{ donations === 'fh' ? 5 : 10 }}</span></a
                >
              </span>
            }
          </div>
        </div>

        @if (fhSheet) {
          <hr class="compact-separator" />
        }
        @if (fhSheet && !gh2eSheet) {
          <div class="row resources" [ngClass]="{ disabled: settingsManager.settings.fhShareResources }">
            <label><span [ghs-label]="'character.progress.resources'"></span>:</label>
            <a class="move" (click)="moveResources()"
              ><span
                [ghs-label]="
                  settingsManager.settings.fhShareResources ? 'character.progress.resources.shared' : 'character.progress.resources.move'
                "
              ></span
            ></a>
            <div class="resource-table">
              <div class="materials">
                @for (resource of materialResourceLootTypes; track resource) {
                  <div class="resource {{ resource }}" [ghs-tooltip]="'game.loot.' + resource">
                    <img [src]="'./assets/images/fh/loot/' + resource + '.svg'" />
                    <input
                      [value]="
                        settingsManager.settings.fhShareResources
                          ? gameManager.game.party.loot[resource] || 0
                          : character.progress.loot[resource] || 0
                      "
                      type="number"
                      min="0"
                      (change)="setResource(resource, $event)"
                    />
                  </div>
                }
              </div>
              <div class="herbs">
                @for (resource of herbResourceLootTypes; track resource) {
                  <div class="resource {{ resource }}" [ghs-tooltip]="'game.loot.' + resource">
                    <img [src]="'./assets/images/fh/loot/' + resource + '.svg'" />
                    <input
                      [value]="
                        settingsManager.settings.fhShareResources
                          ? gameManager.game.party.loot[resource] || 0
                          : character.progress.loot[resource] || 0
                      "
                      type="number"
                      min="0"
                      (change)="setResource(resource, $event)"
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <hr class="compact-separator" />
        @if (fhSheet) {
          <div class="row notes">
            <label
              ><span [ghs-label]="'character.progress.notes'"></span>:
              @if (character.traits.length > 0) {
                <div class="traits">
                  <span class="icon"><img class="ghs-svg" src="./assets/images/fh/character/traits/trait.svg" /></span>
                  @for (trait of character.traits; track trait; let i = $index) {
                    <span class="trait" [ghs-label]="'data.character.traits.' + trait"></span>
                    @if (i < character.traits.length - 1) {
                      <span class="divider">-</span>
                    }
                  }
                </div>
              }
            </label>
            <textarea
              class="ignore-denied"
              [readOnly]="!gameManager.stateManager.characterPermissions[character.name + '|' + character.edition]"
              [value]="character.progress.notes"
              (change)="setNotes($event)"
              [ghs-label]="'character.progress.notes'"
              [ghs-label-attribute]="'placeholder'"
            ></textarea>
          </div>
        }

        @if (!fhSheet) {
          <ghs-character-items class="row" [character]="character"></ghs-character-items>
        }

        @if (fhSheet) {
          <hr class="compact-separator" />
        }
        @if (fhSheet) {
          <div class="row masteries">
            <label><span [ghs-label]="'character.progress.masteries'"></span>:</label>
            <div class="masteries-list">
              @for (mastery of character.masteries; track mastery; let i = $index) {
                <div class="mastery">
                  <span class="checkmark"> <img src="./assets/images/close.svg" />:</span>
                  <span
                    class="mastery-check checkbox"
                    [ngClass]="{ checked: character.progress.masteries.includes(i) }"
                    (click)="toggleMastery(i)"
                  ></span>
                  <span class="placeholder text" [ghs-label]="mastery"></span>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="column column-right">
        @if (!fhSheet) {
          <hr class="compact-separator" />
        }
        <div class="row perks">
          @if (!fhSheet) {
            <label class="headline"><span [ghs-label]="'game.attackModifiers.perks'"></span></label>
          }
          <div
            class="list ignore-denied"
            [ngClass]="{
              denied:
                !editable() ||
                settingsManager.settings.characterSheetLocked ||
                !gameManager.stateManager.characterPermissions[character.name + '|' + character.edition],
              'view-only': !editable() || settingsManager.settings.characterSheetLocked
            }"
          >
            @for (perk of character.perks | trackUUID; track perk._trackUUID; let i = $index) {
              <div class="perk">
                <div class="checkboxes" [ngClass]="{ combined: perk.combined }">
                  @for (count of [] | ghsRange: perk.count; track count) {
                    <span
                      class="checkbox"
                      [ngClass]="{
                        checked: character.progress.perks[i] && character.progress.perks[i] > count,
                        disabled:
                          (!forceEdit() && (gameManager.game.state !== GameState.draw || gameManager.game.round > 0)) ||
                          (character.progress.perks[i] <= count && availablePerks < count - character.progress.perks[i] + 1)
                      }"
                      ghs-pointer-input
                      (singleClick)="addPerk(i, count + 1)"
                      (doubleClick)="addPerk(i, count + 1, true)"
                    ></span>
                  }
                </div>
                <ghs-perk-label
                  ghs-pointer-input
                  (singleClick)="togglePerk(i)"
                  (doubleClick)="togglePerk(i, true)"
                  [ngClass]="{
                    disabled:
                      gameManager.game.state !== GameState.draw ||
                      gameManager.game.round > 0 ||
                      (availablePerks === 0 && !character.progress.perks[i])
                  }"
                  [perk]="perk"
                ></ghs-perk-label>
              </div>
            }
          </div>
          @if (availablePerks < 0) {
            <div class="warning" [ghs-label]="'game.attackModifiers.perks.warning'" [ghs-label-attribute]="'title'">
              <img class="ghs-svg" src="./assets/images/warning.svg" />
              <span [ghs-label]="'game.attackModifiers.perks.warning'"></span>
            </div>
          }
          @if (character.perkWarning) {
            <div class="wip" [ghs-label]="'wip'" [ghs-label-attribute]="'title'">
              <img class="ghs-svg" src="./assets/images/warning.svg" /> <span [ghs-label]="'game.attackModifiers.perks.wip'"></span>
            </div>
          }
        </div>
        <div class="row battlegoals">
          @if (!fhSheet && !csSheet) {
            <label class="headline"><span [ghs-label]="'game.battleGoals'"></span></label>
          }
          @if (fhSheet) {
            <label class="headline"><span [ghs-label]="'game.attackModifiers.perks'"></span></label>
          }
          <div class="battlegoals-grid">
            @for (item of [] | ghsRange: 18; track item) {
              @if (item % 3 === 0) {
                <span class="checkmark">
                  <img [src]="'./assets/images/' + (gh2eSheet || fhSheet ? 'checkmark' : 'check') + '.svg'" />:</span
                >
              }
              <span
                class="battlegoal checkbox"
                [ngClass]="{ checked: character.progress.battleGoals >= item + 1 }"
                (click)="setBattleGoals(item + 1)"
              ></span>
            }
          </div>
        </div>
        @if (fhSheet) {
          <hr class="compact-separator" />
        }
      </div>
    </div>

    <div class="additional">
      <hr class="compact-separator" />
      @if (!settingsManager.settings.characterSheetCompact || !fhSheet) {
        <label class="headline"><span [ghs-label]="'character.progress.notes'"></span></label>
      }
      <div class="columns">
        <div class="column column-left">
          @if (!fhSheet) {
            <textarea
              class="ignore-denied"
              [readOnly]="!gameManager.stateManager.characterPermissions[character.name + '|' + character.edition]"
              [value]="character.progress.notes"
              (change)="setNotes($event)"
              [ghs-label]="'character.progress.notes'"
              [ghs-label-attribute]="'placeholder'"
            ></textarea>
          }

          @if (fhSheet) {
            <ghs-character-items [character]="character"></ghs-character-items>
          }
        </div>
        <div class="column column-right notes">
          <div class="name">
            @if (
              character.number === 0 ||
              character.number > gameManager.game.party.players.length ||
              !gameManager.game.party.players[character.number - 1]
            ) {
              <span>/</span>
            }
            @if (
              character.number > 0 &&
              character.number <= gameManager.game.party.players.length &&
              gameManager.game.party.players[character.number - 1]
            ) {
              <span> {{ gameManager.game.party.players[character.number - 1] }}</span>
            }

            <span class="spacer"></span>
            <a class="ignore-denied" (click)="statistics()" [ghs-tooltip]="'scenario.stats'"
              ><img class="ghs-svg" src="./assets/images/stats.svg"
            /></a>
          </div>
          <div class="player-number">
            <label><span [ghs-label]="'character.playerNumber'"></span>:</label>
            <input [value]="character.number" type="number" min="1" (change)="setPlayerNumber($event)" (keyup)="setPlayerNumber($event)" />
          </div>
          @if (!gameManager.editionRules('jotl')) {
            <div class="personal-quest">
              <label
                ><span [ghs-label]="'character.progress.personalQuest'"></span>:
                @if (personalQuestAutotrackSupported()) {
                  <a
                    class="personal-quest-autotrack ignore-denied"
                    [ngClass]="{ disabled: !character.progress.personalQuestAutotrack }"
                    (click)="editable() && togglePersonalQuestAutotrack()"
                    [ghs-tooltip]="
                      character.progress.personalQuestAutotrack
                        ? 'character.progress.personalQuest.autotrack.enabled'
                        : 'character.progress.personalQuest.autotrack.disabled'
                    "
                  >
                    <img class="ghs-svg" src="./assets/images/automation.svg" />
                  </a>
                }
              </label>
              <div class="personal-quest-card">
                <input class="card-id" [value]="character.progress.personalQuest" type="text" (change)="setPersonalQuest($event)" />
                @if (editable() && !personalQuest) {
                  <a
                    class="draw-personal-quest ignore-denied"
                    (click)="drawPersonalQuest()"
                    [ghs-tooltip]="'character.progress.personalQuest.draw'"
                  >
                    <img class="ghs-svg" src="./assets/images/shuffle.svg" />
                  </a>
                  <label
                    class="retire-button"
                    ghs-pointer-input
                    (singleClick)="retire()"
                    (doubleClick)="retire(true)"
                    [ngClass]="{ disabled: !retireEnabled }"
                  >
                    <img class="ghs-svg" src="./assets/images/trophy.svg" />
                    <span [ghs-label]="'character.progress.retirement'"></span>
                  </label>
                }
                @if (personalQuest) {
                  <span class="personal-quest-name ignore-denied" (click)="openPersonalQuestCard()">
                    <span [ghs-label]="'data.personalQuest.' + personalQuest.edition + '.' + personalQuest.cardId"></span>
                    @if (personalQuest.altId && personalQuest.altId !== personalQuest.cardId) {
                      <span>&nbsp;({{ personalQuest.altId }})</span>
                    }
                  </span>
                }
              </div>
              @if (gameManager.trialsManager.trialsEnabled) {
                <div class="trial">
                  <label><span [ghs-label]="'character.progress.trial'"></span>:</label>
                  <div class="trial-card">
                    <input
                      #trialIndex
                      class="card-id"
                      [value]="
                        character.progress.trial
                          ? settingsManager.settings.fhSecondEdition
                            ? gameManager.trialsManager.cardIdSecondPrinting(+character.progress.trial.name)
                            : character.progress.trial.name
                          : ''
                      "
                      type="text"
                      (change)="setTrial($event)"
                      (keyup)="trialIndex.classList.remove('error')"
                    />
                    @if (fhSheet && character.progress.trial) {
                      <a class="open ignore-denied" (click)="openTrial()"><img src="./assets/images/fh/trials/trial.png" /></a>
                    }
                  </div>
                </div>
              }
              @if (!!personalQuest) {
                <div class="requirements">
                  @for (requirement of personalQuest.requirements | trackUUID; track requirement._trackUUID; let i = $index) {
                    @if (
                      !requirement.requires ||
                      !requirement.requires.length ||
                      !requirement.hidden ||
                      (!!requirement.requires && requirement.requires.length > 0 && personalQuestRequirementUnlocked(i))
                    ) {
                      <div
                        class="requirement"
                        [ngClass]="{
                          disabled: !!requirement.requires && requirement.requires.length > 0 && !personalQuestRequirementUnlocked(i),
                          autotracked: personalQuestRequirementAutotracked(i)
                        }"
                      >
                        <span class="requirement-name">
                          <span [ghs-label]="requirement.name"></span>:
                          @if (EntityValueFunction(requirement.counter) > 1) {
                            <span>&nbsp;{{ getPersonalQuestCount(i) }}/{{ EntityValueFunction(requirement.counter) }}</span>
                          }
                        </span>
                        @if (!requirement.checkbox || !requirement.checkbox.length) {
                          <span class="counter">
                            @if (EntityValueFunction(requirement.counter) < 11) {
                              @for (counter of [] | ghsRange: EntityValueFunction(requirement.counter); track counter) {
                                <span
                                  class="checkbox"
                                  [ngClass]="{ checked: character.progress.personalQuestProgress[i] > counter }"
                                  (click)="setPersonalQuestProgress(i, counter + 1)"
                                  [ghs-label]="'character.progress.personalQuest.counter'"
                                  [ghs-label-attribute]="'title'"
                                ></span>
                              }
                            }
                            @if (EntityValueFunction(requirement.counter) > 10) {
                              <input
                                [value]="character.progress.personalQuestProgress[i]"
                                type="number"
                                min="0"
                                [max]="EntityValueFunction(requirement.counter)"
                                (change)="setPersonalQuestProgress(i, $event)"
                              />
                            }
                          </span>
                        }
                        @if (!!requirement.checkbox && requirement.checkbox.length) {
                          <span class="counter">
                            @for (checkbox of requirement.checkbox; track checkbox; let index = $index) {
                              <label>
                                <span
                                  class="checkbox"
                                  [ngClass]="{ checked: isPersonalQuestCheckboxChecked(i, index) }"
                                  (click)="setPersonalQuestCheckboxProgress(i, index)"
                                ></span>
                                <span class="checkbox-label" [ghs-label]="checkbox"></span>
                              </label>
                            }
                          </span>
                        }
                      </div>
                    }
                  }
                </div>
              }
              @if (!!personalQuest) {
                <div class="rewards">
                  @if (personalQuest.unlockCharacter) {
                    <div
                      class="reward"
                      [ghs-label]="'character.progress.personalQuest.unlockCharacter'"
                      [ghs-label-args]="[personalQuest.unlockCharacter]"
                    ></div>
                  }
                  @if (personalQuest.openEnvelope) {
                    <div
                      class="reward"
                      [ghs-label]="
                        'character.progress.personalQuest.openEnvelope' + (personalQuest.openEnvelope.split(':').length > 1 ? '.alt' : '')
                      "
                      [ghs-label-args]="personalQuest.openEnvelope.split(':')"
                    ></div>
                  }
                  @if (personalQuest.unlockPQ) {
                    <div
                      class="reward"
                      [ghs-label]="'character.progress.personalQuest.unlockPQ'"
                      [ghs-label-args]="[personalQuest.unlockPQ]"
                    ></div>
                  }
                </div>
              }
              @if (editable() && personalQuest) {
                <label
                  class="retire-button"
                  ghs-pointer-input
                  (singleClick)="retire()"
                  (doubleClick)="retire(true)"
                  [ngClass]="{ disabled: !retireEnabled }"
                >
                  <img class="ghs-svg" src="./assets/images/trophy.svg" />
                  <span [ghs-label]="'character.progress.retirement'"></span>
                </label>
              }
            </div>
          }
          @if (!gameManager.editionRules('jotl')) {
            <div class="retirements">
              <label><span [ghs-label]="'character.progress.retirements'"></span>:</label>
              <input
                [value]="character.progress.retirements"
                type="number"
                min="0"
                (change)="setRetirements($event)"
                (keyup)="setRetirements($event)"
              />
            </div>
          }
          <div class="extra-perks">
            <label><span [ghs-label]="'character.progress.perks.extra'"></span>:</label>
            <input
              [value]="character.progress.extraPerks"
              type="number"
              min="0"
              (change)="setExtraPerks($event)"
              (keyup)="setExtraPerks($event)"
            />
          </div>
          @if (editable() && settingsManager.settings.partySheet && !gameManager.game.scenario) {
            <div class="set-aside">
              <label (click)="setAside()">
                <img src="./assets/images/long-rest.svg" /><span [ghs-label]="'character.setAside'"></span>
              </label>
            </div>
          }
          @if (replayable && settingsManager.settings.partySheet) {
            <div class="set-aside">
              <label class="ignore-denied" (click)="replay()">
                <img src="./assets/images/long-rest.svg" /><span [ghs-label]="'character.replay'"></span>
              </label>
            </div>
          }
          <hr class="compact-separator" />
          <div class="import-export">
            <label
              class="export ignore-denied"
              (click)="exportCharacter()"
              [ghs-label]="'character.progress.export'"
              [ghs-label-attribute]="'title'"
            >
              <img src="./assets/images/export.svg" />
              <span [ghs-label]="'character.progress.export'"></span>
            </label>
            <label
              class="import"
              [ghs-label]="'character.progress.import'"
              [ghs-label-attribute]="'title'"
              (click)="ghsInputFullScreenCheck()"
            >
              <input type="file" accept="application/json" (change)="importCharacter($event)" />
              <img src="./assets/images/import.svg" /><span [ghs-label]="'character.progress.import'"></span>
            </label>
          </div>

          <span class="toggle-fh-sheet ignore-denied" (click)="toggleFhSheet()">
            <span [ghs-label]="'character.progress.fh.' + (fhSheet ? 'disable' : 'enable')"></span>
          </span>
        </div>
      </div>
    </div>
  </div>

  @if (hasAbilities) {
    <div class="ability-cards" (click)="openAbilityCards()"></div>
  }
</div>
